/** Dedicated jobs / company workspace (no main payment sidebar). */
export const JOBS_PORTAL_PATH = '/jobs-portal';

/** Public product documentation (no app sidebar). */
export const DOCS_PATH = '/docs';
